import { render, staticRenderFns } from "./photoCarousel.vue?vue&type=template&id=45c98434&"
import script from "./photoCarousel.vue?vue&type=script&lang=js&"
export * from "./photoCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports